import { render, staticRenderFns } from "./actDetailList.vue?vue&type=template&id=2e7d4cb6&scoped=true"
import script from "./actDetailList.vue?vue&type=script&lang=js"
export * from "./actDetailList.vue?vue&type=script&lang=js"
import style0 from "./actDetailList.vue?vue&type=style&index=0&id=2e7d4cb6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d4cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7d4cb6')) {
      api.createRecord('2e7d4cb6', component.options)
    } else {
      api.reload('2e7d4cb6', component.options)
    }
    module.hot.accept("./actDetailList.vue?vue&type=template&id=2e7d4cb6&scoped=true", function () {
      api.rerender('2e7d4cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_promote/components/actDetailList.vue"
export default component.exports